export const KKM_COMMAND_CREATED = '.kkm_command_created'
export const KKM_COMMAND_UPDATED = '.kkm_command_updated'
export const FISCAL_SHIFT_STATUS_CHANGED = '.fiscal_shift.status_changed'
export const ORDER_CANCELED = '.order_canceled'
export const CRM_NOTIFICATION_CREATED = '.crm.notification.created'
export const CRM_NOTIFICATION_UPDATED = '.crm.notification.updated'
export const UPDATE_ORDER = 'Order\\UpdateOrder'
export const CRM_BILLING_PAYMENT_COMPLETED = '.crm.billing.payment.completed'
export const CRM_BILLING_PAYMENT_METHOD_STATUS_CHANGED = '.crm.billing.payment_method.status_changed'
// Летит в публичный канал филиала: только флаг, без сумм
export const CRM_BILLING_BLOCKING_CHANGED = '.crm.billing.blocking.changed'
// Крон перевёл предзаказ в готовку - звук слышат все в канале филиала
export const PREORDER_AUTO_PREPARED = '.order.preorder_auto_prepared'
